import { useQuery } from "@tanstack/react-query";
import api from "../../../utils/api/axiosInstance";

/**
 * React Query hook for fetching user's comments
 * @param {string} userId - User ID
 * @param {boolean} enabled - Whether the query should run
 */
export const useCommentsQuery = (userId, enabled = true) => {
  return useQuery({
    queryKey: ["comments", userId],
    queryFn: async () => {
      const res = await api.get("/users/me/comments");
      return res.data.comments || [];
    },
    enabled: enabled && !!userId,
  });
};
